// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "input[type=file].border-red-500[data-v-c22fa1f0]{outline:2px solid red;outline-offset:2px}", "",{"version":3,"sources":["webpack://./resources/js/wizard/registration/PersonalData.vue"],"names":[],"mappings":"AAAA,iDAAgC,qBAAA,CAAsB,kBAGtD","sourcesContent":["input[type=file].border-red-500{outline:2px solid red;outline-offset:2px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
